<template>
  <div class="un-auth">
    <div class="auth-mention">
      <div class="mention-item">
        <i class="el-icon-info" />公司授权小程序提示【审核成功】后，可使用【小程序】完整功能，包括：
      </div>
      <div class="mention-item second-mention">
        小程序-智能名片：当微信用户访问智能名片时，能获取其微信信息，使其成为线索；能够分享营销素材记录行为轨迹
      </div>
    </div>
    <div class="auth-operate-card">
      <div class="card-left card">
        <div class="card-content">
          <ds-iconfont icon-class="icon-mk-xiaochengxu1 icon-active" />
          <div class="text">
            <div class="text-p">
              1. 请使用和已授权公众号相同主体的小程序
            </div>
            <div class="text-p">
              2. 授权成功后，请等待微信审核，一般1-5个工作日
            </div>
            <div class="text-p">
              3. 授权时请确保所有权限被勾选
            </div>
            <div class="text-p">
              4. 授权完成后请等待跳回后台，点击【已授权完成】确认
            </div>
          </div>
        </div>
        <div
          class="card-button highlight"
          @click="toAuth"
        >
          已有小程序，立即绑定
        </div>
      </div>
      <div class="card-right card">
        <div class="card-content">
          <ds-iconfont icon-class="icon-mk-xiaochengxu1" />
          <div class="text">
            <div class="text-p">
              请在微信小程序平台申请新的小程序
            </div>
            <div class="text-p">
              成功后再到此页面进行绑定
            </div>
          </div>
        </div>
        <div
          class="card-button"
          @click="getMp"
        >
          没有小程序，立即申请
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnAuth',
  methods: {
    toAuth () {
      const { VUE_APP_WX_OPEN_BASE_URL } = process.env
      const dustessUrl = encodeURIComponent(
        window.location.origin + '/#/settings/auth-management?type=2'
      )
      const { account } = JSON.parse(window.localStorage.getItem('user'))
      const url = `${VUE_APP_WX_OPEN_BASE_URL}/wxopen/v1/mini/auth/page?companyId=${account}&dustessUrl=${dustessUrl}`
      window.open(url)
      this.$emit('validateDialog', true)
    },
    getMp () {
      window.open('https://mp.weixin.qq.com')
    }
  }
}
</script>

<style lang="scss" scoped>
.un-auth {
  padding: 23px 25px 0;

  .auth-mention {
    padding: 5px 16px;
    background: #f2fbff;
    border: 1px solid #ccecff;
    border-radius: 4px;

    .mention-item {
      color: #000;
      font-size: 14px;
      line-height: 30px;

      .el-icon-info {
        color: #009cff;
        margin-right: 8px;
        font-size: 16px;
      }
    }

    .second-mention {
      margin-left: 22px;
    }
  }

  .auth-operate-card {
    margin-top: 23px;
    display: flex;

    .card-left {
      margin-right: 23px;
    }

    .card {
      width: 470px;
      border: 1px solid rgba(233, 233, 233, 1);

      .card-content {
        height: 136px;
        padding: 24px 24px 12px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .icon-mk-xiaochengxu1 {
          font-size: 48px;
          color: #d9d9d9;
          margin-right: 16px;
        }

        .icon-active {
          color: #4ac718;
        }

        .text {
          .text-p {
            font-size: 14px;
            line-height: 25px;
            color: rgba(0, 0, 0, 0.45);
          }
        }
      }

      .card-button {
        height: 48px;
        line-height: 48px;
        text-align: center;
        background: rgba(247, 249, 250, 1);
        border-radius: 0 0 2px 2px;
        border-top: 1px solid rgba(233, 233, 233, 1);
        color: rgba(0, 0, 0, 0.45);
        cursor: pointer;

        &.highlight {
          color: #009cff;
        }

        &:hover {
          background-color: #009cff;
          color: #fff;
        }
      }
    }
  }
}
</style>
